export default interface NewInterface {
    id: string;
    title: string;
    description: string;
    file: any;
    dtNew:string;
    authorId: string;
    published: boolean;
    imageContent: any;
    imageContentType:string;
    imageTitle: string;
    link: string;
    entryDateTime: string;
    updateDateTime: string;    
  }
  
  const newInitialValue: NewInterface = {
    id: String(),
    title: String(),
    description: String(),
    file: {},
    dtNew: String(),
    authorId: String(),
    published: Boolean(),
    imageContent: {},
    imageContentType:String(),
    imageTitle: String(),
    link: String(),
    entryDateTime: String(),
    updateDateTime: String(),   
  };
  
  export { newInitialValue };
  